import styled from "@emotion/styled";
import type { ReactNode, CSSProperties, Ref } from "react";

export interface FlexCenterProps {
  children?: ReactNode;
  maxWidth?: string;
  textAlign?: boolean;
  className?: string;
  style?: CSSProperties;
  "data-testid"?: string;
  ref?: Ref<HTMLDivElement>;
  y?: "top" | "center" | "bottom";
  fullHeight?: boolean;
  alignItems?: CSSProperties["alignItems"];
}

const Container = styled.div`
  flex: 1;
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: stretch;
  flex-direction: column;
  min-height: 100%;
  box-sizing: border-box;

  &[data-text-center="true"] {
    text-align: center;
  }

  &[data-content-y="top"] {
    justify-content: flex-start;
  }

  &[data-content-y="bottom"] {
    justify-content: flex-end;
  }

  &[data-full-height="true"] {
    height: 100%;
  }
`;

const FlexCenter = ({
  children,
  textAlign = false,
  className,
  style,
  "data-testid": dataTestId,
  ref,
  y = "center",
  fullHeight = false
}: FlexCenterProps) => {
  return (
    <Container
      ref={ref}
      className={className}
      style={{
        ...style,
        alignItems: style?.alignItems ?? "stretch"
      }}
      data-text-center={textAlign ? "true" : undefined}
      data-testid={dataTestId}
      data-content-y={y}
      data-full-height={fullHeight ? "true" : undefined}
    >
      {children}
    </Container>
  );
};

export default FlexCenter;
